import { gql } from '@apollo/client'
import { Price } from '@jusbrasil-web/shared-price'

import { ChooseFrequencyLaterOfferCardPrice_OfferLockOfferFragment } from './__generated__/choose-frequency-later-offer-card-price.graphql'

interface ChooseFrequencyLaterOfferCardPriceProps {
  offerLockOffer: ChooseFrequencyLaterOfferCardPrice_OfferLockOfferFragment
  className?: string
}

export const ChooseFrequencyLaterOfferCardPrice = ({
  className,
  offerLockOffer,
}: ChooseFrequencyLaterOfferCardPriceProps) => {
  const {
    priceTitlePlansSection,
    priceText,
    frequencyPeriodText,
    priceAfterPromotionalPeriodText,
  } = offerLockOffer

  const isPromotional = !!priceAfterPromotionalPeriodText

  const getPriceText = () => {
    if (isPromotional) {
      return (
        <span>
          <Price.Value>{priceText}</Price.Value>
          <Price.Helptext> no {frequencyPeriodText}</Price.Helptext>
        </span>
      )
    }

    return (
      <span>
        <Price.Value>{priceText}</Price.Value>
        <Price.ValueFrequency>mês</Price.ValueFrequency>
      </span>
    )
  }

  return (
    <Price className={className}>
      {priceTitlePlansSection && (
        <Price.Title>
          <span dangerouslySetInnerHTML={{ __html: priceTitlePlansSection }} />
        </Price.Title>
      )}

      {getPriceText()}
    </Price>
  )
}

ChooseFrequencyLaterOfferCardPrice.fragments = {
  offerLockOffer: gql`
    fragment ChooseFrequencyLaterOfferCardPrice_offerLockOffer on OfferLockOffer {
      priceTitlePlansSection
      priceText
      frequency
      frequencyPeriodText
      priceAfterPromotionalPeriodText
    }
  `,
}
